var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CenteredButton from '../CenteredButton';
import ButtonAnimator from '../ButtonAnimator';

var audioButtonControllerPropTypes = {
  audioSource: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  autoPlay: PropTypes.bool
};

var audioButtonControllerDefaultProps = {
  audioSource: false,
  autoPlay: false
};

var AudioButtonController = function (_Component) {
  _inherits(AudioButtonController, _Component);

  function AudioButtonController(props) {
    _classCallCheck(this, AudioButtonController);

    var _this = _possibleConstructorReturn(this, (AudioButtonController.__proto__ || Object.getPrototypeOf(AudioButtonController)).call(this, props));

    _this.renderAudio = function () {
      var className = _this.props.className;
      var _this$state = _this.state,
          playAudio = _this$state.playAudio,
          completeAudio = _this$state.completeAudio;


      if (completeAudio) {
        return React.createElement(CenteredButton, { key: 'audioButtonComplete', icon: 'icon-volume-off', onClick: _this.startAudio, className: className, theme: 'tooltipRound' });
      }

      return React.createElement(ButtonAnimator, {
        key: 'audioButton',
        values: ['icon-volume-low', 'icon-volume-medium', 'icon-volume-high', 'icon-volume-medium', 'icon-volume-low'],
        showOnPause: 1,
        onClick: _this.toggleAudio,
        className: className,
        paused: !playAudio
      });
    };

    _this.startAudio = function (e) {
      var completeAudio = _this.state.completeAudio;

      e.stopPropagation();

      var mediaNodes = document.querySelectorAll('video, audio');
      mediaNodes.forEach(function (media) {
        return media.pause();
      });
      if (completeAudio) {
        _this.$audio.currentTime = 0;
        _this.$audio.load();
      }
      _this.$audio.play();
    };

    _this.toggleAudio = function (e) {
      e.stopPropagation();
      var playAudio = _this.state.playAudio;

      if (playAudio) {
        _this.$audio.pause();
      } else {
        _this.startAudio(e);
      }
    };

    _this.onPlay = function () {
      _this.setState({
        completeAudio: false,
        playAudio: true
      });
    };

    _this.onPause = function () {
      _this.setState({
        playAudio: false
      });
    };

    _this.audioEnded = function () {
      _this.setState({
        completeAudio: true,
        playAudio: false
      });
    };

    _this.$audio = null;

    _this.state = {
      playAudio: true,
      completeAudio: !props.autoPlay
    };
    return _this;
  }

  _createClass(AudioButtonController, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      var id = this.props.id;

      if (this.$audio) {
        if (id !== nextProps.id || this.context.enteredAnswer !== null && nextContext.enteredAnswer === null) {
          this.setState({
            completeAudio: true
          });
          this.$audio.pause();
          this.$audio.load();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          audioSource = _props.audioSource,
          autoPlay = _props.autoPlay;

      return [this.renderAudio(), React.createElement(
        'audio',
        {
          key: 'audioSource',
          ref: function ref(audio) {
            _this2.$audio = audio;
          },
          onPlay: this.onPlay,
          onPause: this.onPause,
          onEnded: this.audioEnded,
          autoPlay: autoPlay
        },
        React.createElement('source', { src: audioSource, type: 'audio/mp3' }),
        'Your browser does not support the audio element.'
      )];
    }
  }]);

  return AudioButtonController;
}(Component);

export default AudioButtonController;

AudioButtonController.propTypes = process.env.NODE_ENV !== "production" ? Object.assign({}, audioButtonControllerPropTypes) : {};

AudioButtonController.defaultProps = Object.assign({}, audioButtonControllerDefaultProps);

AudioButtonController.contextTypes = {
  enteredAnswer: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))])
};

export { audioButtonControllerPropTypes, audioButtonControllerDefaultProps };